// Golden Nominal = one existing Dataset nominated as the authoritative dataset for
// its Schema (one per schema). Drives dedup survivorship, persistence and reference.
// There is no global "golden map" endpoint — each dataset/search/dedup record carries
// `isGoldenNominal`, and this store only holds in-session nominate/revoke overrides
// (combined via common/goldenNominal `isDatasetGolden`).
export const NOMINATE_GOLDEN_NOMINAL_REQUEST = "NOMINATE_GOLDEN_NOMINAL_REQUEST";
export const NOMINATE_GOLDEN_NOMINAL_SUCCESS = "NOMINATE_GOLDEN_NOMINAL_SUCCESS";
export const NOMINATE_GOLDEN_NOMINAL_FAILURE = "NOMINATE_GOLDEN_NOMINAL_FAILURE";

export const DENOMINATE_GOLDEN_NOMINAL_REQUEST = "DENOMINATE_GOLDEN_NOMINAL_REQUEST";
// PRE-2379 — source-type tier set/clear (GOLDEN_NOMINAL moves only via nominate/revoke).
export const SET_PRECEDENCE_TIER_REQUEST = "SET_PRECEDENCE_TIER_REQUEST";
export const SET_PRECEDENCE_TIER_SUCCESS = "SET_PRECEDENCE_TIER_SUCCESS";
export const SET_PRECEDENCE_TIER_FAILURE = "SET_PRECEDENCE_TIER_FAILURE";
export const DENOMINATE_GOLDEN_NOMINAL_SUCCESS = "DENOMINATE_GOLDEN_NOMINAL_SUCCESS";
export const DENOMINATE_GOLDEN_NOMINAL_FAILURE = "DENOMINATE_GOLDEN_NOMINAL_FAILURE";

// PUT /businessareas/:businessAreaId/schemas/:schemaId/datasets/:dataSetId/golden
export const nominateGoldenNominalRequest = (businessAreaId, schemaId, dataSetId) => ({
    type: NOMINATE_GOLDEN_NOMINAL_REQUEST,
    params: { businessAreaId, schemaId, dataSetId },
});
export const nominateGoldenNominalSuccess = (result) => ({ type: NOMINATE_GOLDEN_NOMINAL_SUCCESS, payload: result });
export const nominateGoldenNominalFailure = (error) => ({ type: NOMINATE_GOLDEN_NOMINAL_FAILURE, payload: error });

// DELETE /businessareas/:businessAreaId/schemas/:schemaId/datasets/:dataSetId/golden
export const denominateGoldenNominalRequest = (businessAreaId, schemaId, dataSetId) => ({
    type: DENOMINATE_GOLDEN_NOMINAL_REQUEST,
    params: { businessAreaId, schemaId, dataSetId },
});
export const denominateGoldenNominalSuccess = (result) => ({ type: DENOMINATE_GOLDEN_NOMINAL_SUCCESS, payload: result });
export const denominateGoldenNominalFailure = (error) => ({ type: DENOMINATE_GOLDEN_NOMINAL_FAILURE, payload: error });

// PUT /businessareas/:businessAreaId/schemas/:schemaId/datasets/:dataSetId/precedence
export const setPrecedenceTierRequest = (businessAreaId, schemaId, dataSetId, tier) => ({
    type: SET_PRECEDENCE_TIER_REQUEST,
    params: { businessAreaId, schemaId, dataSetId, tier },
});
export const setPrecedenceTierSuccess = (dataSet) => ({ type: SET_PRECEDENCE_TIER_SUCCESS, payload: dataSet });
export const setPrecedenceTierFailure = (error) => ({ type: SET_PRECEDENCE_TIER_FAILURE, payload: error });

// PRE-2797 — a dataset's role (UTILITY: a transient feed that can be truncated), and truncating it.
export const SET_DATASET_ROLE_REQUEST = "SET_DATASET_ROLE_REQUEST";
export const SET_DATASET_ROLE_SUCCESS = "SET_DATASET_ROLE_SUCCESS";
export const SET_DATASET_ROLE_FAILURE = "SET_DATASET_ROLE_FAILURE";
export const TRUNCATE_DATASET_REQUEST = "TRUNCATE_DATASET_REQUEST";
export const TRUNCATE_DATASET_SUCCESS = "TRUNCATE_DATASET_SUCCESS";
export const TRUNCATE_DATASET_FAILURE = "TRUNCATE_DATASET_FAILURE";

export const setDataSetRoleRequest = (businessAreaId, schemaId, dataSetId, role) => ({
    type: SET_DATASET_ROLE_REQUEST,
    params: { businessAreaId, schemaId, dataSetId, role },
});
export const setDataSetRoleSuccess = (dataSet) => ({ type: SET_DATASET_ROLE_SUCCESS, payload: dataSet });
export const setDataSetRoleFailure = (error) => ({ type: SET_DATASET_ROLE_FAILURE, payload: error });
export const truncateDataSetRequest = (businessAreaId, schemaId, dataSetId) => ({
    type: TRUNCATE_DATASET_REQUEST,
    params: { businessAreaId, schemaId, dataSetId },
});
export const truncateDataSetSuccess = (dataSetId, jobId) => ({ type: TRUNCATE_DATASET_SUCCESS, payload: { dataSetId, jobId } });
export const truncateDataSetFailure = (error) => ({ type: TRUNCATE_DATASET_FAILURE, payload: error });

// What the signed-in user may do in golden record stewardship (permission resource
// goldenstewardship). Its actions are its own, not add/view/edit/delete. Screens that act on it
// (the review queue, breaking a schema lock) dispatch the request when they load; until then
// every flag is false.
export const GET_GOLDEN_STEWARDSHIP_PERMISSION_REQUEST = "GET_GOLDEN_STEWARDSHIP_PERMISSION_REQUEST";
export const GET_GOLDEN_STEWARDSHIP_PERMISSION_SUCCESS = "GET_GOLDEN_STEWARDSHIP_PERMISSION_SUCCESS";
export const GET_GOLDEN_STEWARDSHIP_PERMISSION_FAILURE = "GET_GOLDEN_STEWARDSHIP_PERMISSION_FAILURE";

// goldenstewardship actions -> the flag each one sets. Matched case-insensitively, as the services do.
export const GOLDEN_STEWARDSHIP_ACTIONS = Object.freeze({
    review: "canReview",
    retire: "canRetire",
    restore: "canRestore",
    purge: "canPurge",
    truncate: "canTruncate",
    admin_break_lock: "canBreakLock",
});

export const NO_GOLDEN_STEWARDSHIP_PERMISSION = Object.freeze(
    Object.fromEntries(Object.values(GOLDEN_STEWARDSHIP_ACTIONS).map((flag) => [flag, false]))
);

export const getGoldenStewardshipPermissionRequest = () => ({ type: GET_GOLDEN_STEWARDSHIP_PERMISSION_REQUEST });
export const getGoldenStewardshipPermissionSuccess = (permission) => ({ type: GET_GOLDEN_STEWARDSHIP_PERMISSION_SUCCESS, payload: { permission } });
export const getGoldenStewardshipPermissionFailure = (error) => ({ type: GET_GOLDEN_STEWARDSHIP_PERMISSION_FAILURE, payload: { error } });
